'use strict';

const commonBuildtimeEnvKeys = [
  "APP_VERSION",
  "NODE_ENV",
  // 런타임에 넣어줘도 되는데 빌드타임에서 넣고 있어서 일단 넣어둠
  "NEXT_PUBLIC_STATIC_FILE_HOST"
];
const nextBuildtimeEnvKeys = [
  "NEXT_IS_SERVER",
  "IS_PRODUCTION_BUILD"
];
const mfBuildtimeEnvKeys = [
  "MF_APP_ID",
  "MF_APPS_URL_MAP",
  "MF_APP_BASE_PATH"
];
const buildtimeEnvKeys = [
  ...commonBuildtimeEnvKeys,
  ...mfBuildtimeEnvKeys,
  ...nextBuildtimeEnvKeys
];

exports.buildtimeEnvKeys = buildtimeEnvKeys;
exports.commonBuildtimeEnvKeys = commonBuildtimeEnvKeys;
exports.mfBuildtimeEnvKeys = mfBuildtimeEnvKeys;
exports.nextBuildtimeEnvKeys = nextBuildtimeEnvKeys;
//# sourceMappingURL=buildtime.cjs.map
